var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 5.47826C4.79594 5.47826 4 4.69963 4 3.73913C4 2.77864 4.79594 2 5.77778 2C6.75962 2 7.55556 2.77864 7.55556 3.73913C7.55556 4.69963 6.75962 5.47826 5.77778 5.47826Z",
    fill: "#3A3A42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 11.7391C4.79594 11.7391 4 10.9605 4 10C4 9.03951 4.79594 8.26087 5.77778 8.26087C6.75962 8.26087 7.55556 9.03951 7.55556 10C7.55556 10.9605 6.75962 11.7391 5.77778 11.7391Z",
    fill: "#3A3A42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77778 18C4.79594 18 4 17.2214 4 16.2609C4 15.3004 4.79594 14.5217 5.77778 14.5217C6.75962 14.5217 7.55555 15.3004 7.55555 16.2609C7.55555 17.2214 6.75962 18 5.77778 18Z",
    fill: "#3A3A42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 5.47826C13.2404 5.47826 12.4445 4.69963 12.4445 3.73913C12.4445 2.77864 13.2404 2 14.2222 2C15.2041 2 16 2.77864 16 3.73913C16 4.69963 15.2041 5.47826 14.2222 5.47826Z",
    fill: "#3A3A42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 11.7391C13.2404 11.7391 12.4445 10.9605 12.4445 10C12.4445 9.03951 13.2404 8.26087 14.2222 8.26087C15.2041 8.26087 16 9.03951 16 10C16 10.9605 15.2041 11.7391 14.2222 11.7391Z",
    fill: "#3A3A42"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2222 18C13.2404 18 12.4445 17.2214 12.4445 16.2609C12.4445 15.3004 13.2404 14.5217 14.2222 14.5217C15.2041 14.5217 16 15.3004 16 16.2609C16 17.2214 15.2041 18 14.2222 18Z",
    fill: "#3A3A42"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonIcon);
export default __webpack_public_path__ + "static/media/dragonIcon.c65d03b911511b0b302ecba618a9ab57.svg";
export { ForwardRef as ReactComponent };